import { render, staticRenderFns } from "./AllObjectsModal.vue?vue&type=template&id=226018ba"
import script from "./AllObjectsModal.vue?vue&type=script&lang=ts"
export * from "./AllObjectsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports